/**
 * Énumérations CRM structurantes.
 * Référence : document 09 — épopées E06 à E08.
 */
/** Statuts du prospect sur le premier incrément CRM. */
export const PROSPECT_STATUSES = [
    'new',
    'to_qualify',
    'qualified',
    'negotiation',
    'archived',
];
/** Types de tiers CRM partagés entre prospects et clients. */
export const CRM_PARTY_KINDS = ['individual', 'company', 'association'];
/** Périmètre géographique d'une société. */
export const CRM_COMPANY_SCOPES = ['france', 'eea', 'non_eea'];
/** Types de clients du premier incrément. */
export const CLIENT_TYPES = ['company', 'individual', 'association', 'public'];
/** Statuts du client sur le premier incrément CRM. */
export const CLIENT_STATUSES = ['active', 'inactive', 'archived'];
/**
 * Statuts d'une opportunité commerciale.
 * `open` tant que l'affaire est en cours, puis `won` ou `lost` selon l'étape finale atteinte.
 */
export const OPPORTUNITY_STATUSES = ['open', 'won', 'lost'];
/** Types d'activité CRM consignée au fil d'une entité (E08-07). */
export const CRM_ACTIVITY_TYPES = ['call', 'email', 'meeting', 'note'];
/** Sens d'une activité entrante ou sortante. */
export const CRM_ACTIVITY_DIRECTIONS = ['inbound', 'outbound'];
/** Statuts d'une tâche CRM (E08-08). */
export const CRM_TASK_STATUSES = ['todo', 'in_progress', 'done', 'cancelled'];
/** Niveaux de priorité d'une tâche CRM. */
export const CRM_TASK_PRIORITIES = ['low', 'normal', 'high', 'urgent'];
/** Canaux de diffusion d'un rappel de tâche. */
export const CRM_REMINDER_CHANNELS = ['in_app', 'email', 'sms'];
//# sourceMappingURL=crm.enum.js.map